// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { MapScriptEntWeight, MapScriptEntWeightT } from '../tbs/map-script-ent-weight.js';


export class MapScriptStage implements flatbuffers.IUnpackableObject<MapScriptStageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MapScriptStage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMapScriptStage(bb:flatbuffers.ByteBuffer, obj?:MapScriptStage):MapScriptStage {
  return (obj || new MapScriptStage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMapScriptStage(bb:flatbuffers.ByteBuffer, obj?:MapScriptStage):MapScriptStage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MapScriptStage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

coverageRatio():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 1.0;
}

entWeights(index: number, obj?:MapScriptEntWeight):MapScriptEntWeight|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new MapScriptEntWeight()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

entWeightsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

clobber():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
}

static startMapScriptStage(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addCoverageRatio(builder:flatbuffers.Builder, coverageRatio:number) {
  builder.addFieldFloat64(0, coverageRatio, 1.0);
}

static addEntWeights(builder:flatbuffers.Builder, entWeightsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, entWeightsOffset, 0);
}

static createEntWeightsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startEntWeightsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addClobber(builder:flatbuffers.Builder, clobber:number) {
  builder.addFieldInt8(2, clobber, 0);
}

static endMapScriptStage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createMapScriptStage(builder:flatbuffers.Builder, coverageRatio:number, entWeightsOffset:flatbuffers.Offset, clobber:number):flatbuffers.Offset {
  MapScriptStage.startMapScriptStage(builder);
  MapScriptStage.addCoverageRatio(builder, coverageRatio);
  MapScriptStage.addEntWeights(builder, entWeightsOffset);
  MapScriptStage.addClobber(builder, clobber);
  return MapScriptStage.endMapScriptStage(builder);
}

unpack(): MapScriptStageT {
  return new MapScriptStageT(
    this.coverageRatio(),
    this.bb!.createObjList<MapScriptEntWeight, MapScriptEntWeightT>(this.entWeights.bind(this), this.entWeightsLength()),
    this.clobber()
  );
}


unpackTo(_o: MapScriptStageT): void {
  _o.coverageRatio = this.coverageRatio();
  _o.entWeights = this.bb!.createObjList<MapScriptEntWeight, MapScriptEntWeightT>(this.entWeights.bind(this), this.entWeightsLength());
  _o.clobber = this.clobber();
}
}

export class MapScriptStageT implements flatbuffers.IGeneratedObject {
constructor(
  public coverageRatio: number = 1.0,
  public entWeights: (MapScriptEntWeightT)[] = [],
  public clobber: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const entWeights = MapScriptStage.createEntWeightsVector(builder, builder.createObjectOffsetList(this.entWeights));

  return MapScriptStage.createMapScriptStage(builder,
    this.coverageRatio,
    entWeights,
    this.clobber
  );
}
}
